export default "__VITE_ASSET__J_8AdJ5q__"